import { useTheme } from 'styled-components';

interface ActivityArrowIconProps {
  secondary?: boolean;
}

export const ActivityArrowIcon: React.FC<ActivityArrowIconProps> = ({ secondary }) => {
  const theme = useTheme();
  return (
    <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.561 14.8072L0.715788 13.4107C0.602461 13.3928 0.603588 13.2292 0.717151 13.2129L9.57507 11.9392L9.58432 9.38833C9.58495 9.21544 9.78984 9.12474 9.91825 9.24052L14.4105 13.2908C14.4985 13.3702 14.4986 13.5083 14.4106 13.5878L9.91919 17.6442C9.79119 17.7598 9.58669 17.6701 9.58514 17.4976L9.561 14.8072Z"
        fill={secondary ? theme.secondary.softBlue1 : theme.algoanBlue}
      />
    </svg>
  );
};
